import React, { useContext, useEffect, useState } from 'react';
import { View, Switch } from 'react-native';
import { DataContext } from 'opidcore';

import { SmallLabel } from '../Styles';

const InputToggle = ({field, label = undefined, onChange = undefined, defaultValue = false, style = {}, disabled = false}) => {
    const boundMagic = useContext(DataContext);
    const [isEnabled, setIsEnabled] = useState(boundMagic.magicalGet(field, defaultValue));

    useEffect(()=>{
        //initial setup for the boundMagic
        boundMagic.magicalState(field, (val)=>{
            //if we have a custom change event it will be called here once boundMagic has a new value
            setIsEnabled(val);
        });
    },[boundMagic]);

    useEffect(()=>{
        setIsEnabled(boundMagic.magicalGet(field, defaultValue));
    }, [defaultValue]);

    useEffect(()=>{
        if(onChange != undefined){
            onChange(boundMagic, field, isEnabled);
        }
    }, [isEnabled])

    return <View style={style}>
        {label == undefined? null : <SmallLabel>{label}</SmallLabel>}
        <Switch
            trackColor={{ false: "#767577", true: "#81b0ff" }}
            thumbColor={isEnabled ? "#f5dd4b" : "#f4f3f4"}
            ios_backgroundColor="#3e3e3e"
            disabled={disabled}
            onValueChange={(v)=>boundMagic.magicalSet(field, v)}
            value={isEnabled}
        />
    </View>;
}

export default InputToggle;